
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ServicioItem = ({ servicio, index }: { servicio: typeof servicios[number]; index: number }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <div
      ref={ref}
      className={`flex flex-col ${
        index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
      } gap-12 items-center`}
    >
      <div
        className={`flex-1 transition-all duration-700 ${
          isVisible
            ? 'opacity-100 translate-x-0'
            : index % 2 === 0
            ? 'opacity-0 -translate-x-12'
            : 'opacity-0 translate-x-12'
        }`}
      >
        <div className="w-16 h-16 bg-emerald-600 rounded-xl flex items-center justify-center mb-6">
          <i className={`${servicio.icon} text-white text-3xl`}></i>
        </div>
        <h3 className="text-3xl font-bold text-gray-900 mb-4">
          <strong>{servicio.title}</strong>
        </h3>
        <p className="text-lg text-gray-600 mb-6 leading-relaxed">
          {servicio.description}
        </p>
        <ul className="space-y-3">
          {servicio.features.map((feature, idx) => (
            <li key={idx} className="flex items-start space-x-3">
              <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mt-0.5"></i>
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
        <div className="mt-8">
          <a
            href="tel:932932913"
            className="inline-flex items-center space-x-2 bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-fill"></i>
            <span>Solicitar Servicio</span>
          </a>
        </div>
      </div>

      <div
        className={`flex-1 transition-all duration-700 delay-200 ${
          isVisible
            ? 'opacity-100 translate-x-0'
            : index % 2 === 0
            ? 'opacity-0 translate-x-12'
            : 'opacity-0 -translate-x-12'
        }`}
      >
        <div className="w-full h-96 rounded-2xl overflow-hidden shadow-xl">
          <img
            src={servicio.image}
            alt={servicio.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </div>
  );
};

const servicios = [
  {
    title: 'Compra de Coches Siniestrados en Gavá',
    description: 'Compramos vehículos con daños por accidente, colisión o siniestro total en Gavá y comarca. No importa el estado del coche, te ofrecemos una valoración justa y competitiva. Trabajamos con todas las marcas y modelos.',
    features: [
      'Valoración gratuita en menos de 2 horas',
      'Compramos coches con pérdida total',
      'Aceptamos vehículos con daños estructurales',
      'Pago inmediato en efectivo o transferencia',
    ],
    icon: 'ri-car-fill',
    image: 'https://public.readdy.ai/ai/img_res/a9dfb452f7959da8772a5bc22c43d084.jpg',
  },
  {
    title: 'Compra de Coches Accidentados en Gavá',
    description: 'Especialistas en la compra de coches accidentados en Gavá. Desde pequeños golpes hasta accidentes graves, compramos tu vehículo accidentado al mejor precio. Sin importar la marca, modelo o año del coche.',
    features: [
      'Compramos coches con cualquier tipo de accidente',
      'Valoración profesional y transparente',
      'Aceptamos vehículos con daños múltiples',
      'Proceso rápido en menos de 24 horas',
    ],
    icon: 'ri-car-washing-fill',
    image: 'https://readdy.ai/api/search-image?query=accident%20damaged%20vehicle%20with%20side%20impact%20collision%20dented%20doors%20broken%20windows%20crashed%20automobile%20on%20clean%20white%20background%20professional%20studio%20photography%20realistic%20detailed%20angle%20view%20modern%20car&width=800&height=600&seq=servicio-detail-005&orientation=landscape',
  },
  {
    title: 'Compra de Coches Averiados en Gavá',
    description: 'Si tu coche tiene averías mecánicas graves, problemas de motor, caja de cambios o cualquier fallo que haga inviable su reparación, te lo compramos en Gavá. Evita gastos innecesarios en reparaciones costosas.',
    features: [
      'Compramos coches que no arrancan',
      'Aceptamos vehículos con averías de motor',
      'Sin necesidad de reparar nada',
      'Recogida gratuita en Gavá y alrededores',
    ],
    icon: 'ri-tools-fill',
    image: 'https://readdy.ai/api/search-image?query=broken%20down%20old%20car%20with%20open%20hood%20showing%20engine%20problems%20mechanical%20failure%20worn%20vehicle%20on%20clean%20white%20background%20professional%20studio%20photography%20realistic%20detailed%20front%20angle%20view&width=800&height=600&seq=servicio-detail-002&orientation=landscape',
  },
  {
    title: 'Retirada Gratuita de Vehículos en Gavá',
    description: 'Nos desplazamos a cualquier punto de Gavá, Castelldefels, Viladecans y comarca para recoger tu vehículo. Servicio de grúa 100% gratuito, sin coste adicional, sin letra pequeña.',
    features: [
      'Servicio de grúa incluido sin coste',
      'Recogida en 24-48 horas',
      'Cobertura en toda la comarca del Baix Llobregat',
      'Atención personalizada y profesional',
    ],
    icon: 'ri-truck-fill',
    image: 'https://readdy.ai/api/search-image?query=professional%20tow%20truck%20flatbed%20vehicle%20transporting%20damaged%20car%20modern%20recovery%20service%20on%20clean%20white%20background%20studio%20lighting%20realistic%20detailed%20side%20view%20commercial%20towing%20equipment&width=800&height=600&seq=servicio-detail-003&orientation=landscape',
  },
  {
    title: 'Gestión Completa de Documentación',
    description: 'Nos encargamos de todos los trámites administrativos: baja definitiva en tráfico, certificado de destrucción y cualquier gestión necesaria. Tú no tienes que preocuparte por nada en Gavá.',
    features: [
      'Tramitación de baja de tráfico',
      'Certificado de destrucción oficial',
      'Asesoramiento legal completo',
      'Sin costes ocultos ni sorpresas',
    ],
    icon: 'ri-file-list-3-fill',
    image: 'https://readdy.ai/api/search-image?query=official%20documents%20paperwork%20forms%20on%20desk%20with%20pen%20administrative%20documentation%20legal%20papers%20on%20clean%20white%20background%20professional%20office%20photography%20realistic%20detailed%20top%20view%20organized%20workspace&width=800&height=600&seq=servicio-detail-004&orientation=landscape',
  },
];

const ServiciosDetalle = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 transition-all duration-700 ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Servicios de <strong>Desguace en Gavá</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ofrecemos soluciones integrales para la compra y gestión de vehículos siniestrados y averiados en Gavá y toda la comarca del Baix Llobregat
          </p>
        </div>

        <div className="space-y-20">
          {servicios.map((servicio, index) => (
            <ServicioItem key={index} servicio={servicio} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiciosDetalle;
